module.exports = __webpack_public_path__ + "static/media/od_1.31fed2e1.jpg";